import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ECalendarType, IJourneyResp as IJourneyResponse } from '../../services/journey.service';
import { IUser } from '../../models/IUser';
import { CalendarServiceType } from '../../models/ICalendarServiceType';

interface Journeys {
  activeJourneys: IJourneyResponse[];
  doneJourneys: IJourneyResponse[];
}

const initialState: Journeys = {
  activeJourneys: [
    {
      status: '',
      journeyid: '',
      schedules: [
        {
          address: {
            address: '',
            addressComplement: '',
            addressNumber: '',
            addressReference: '',
            cep: '',
            city: '',
            neighborhood: '',
            state: '',
            alias: ''
          },
          dateStart: '',
          dateEnd: '',
          id: '',
          returnSchedule: false,
          status: '',
          type: '',
          calendarId: '',
          calendar: {
            id: '',
            alias: '',
            type: ''
          },
          teleUrl: '',
          allowReschedule: false,
          isNeedCollectCSAT: false,
          user: {} as IUser,
          calendarServiceType: {} as CalendarServiceType,
          attendanceConfirmed: false
        }
      ],
      payments: [],
      product: {
        id: '',
        name: '',
        alias: ''
      },
      haveToAnswerAnamnese: '',
      doctor: {
        name: '',
        profileImage: '',
        profileUrl: '',
        id: ''
      },
      steps: {
        currentStep: '',
        nextSteps: '',
        previousSteps: ''
      },
      calendars: [
        {
          id: '',
          durationEvent: 0,
          type: '',
          alias: '',
          inviteFisicalAddress: ''
        }
      ],
      calendarSecundary: {
        id: '',
        durationEvent: 0,
        type: '',
        alias: '',
        inviteFisicalAddress: ''
      },
      files: {
        exams: [],
        reports: [],
        requests: [],
        surgicalReports: [],
        surgicalVideos: []
      },
      calendarTypes: [
        {
          calendarId: '',
          id: '',
          type: ECalendarType.MAIN,
          createdAt: '',
          productId: '',
          updatedAt: ''
        }
      ],
      canScheduleReturn: false,
      restrictReturn: false,
      scheduleTreatments: []
    }
  ],
  doneJourneys: [
    {
      status: '',
      journeyid: '',
      schedules: [
        {
          address: {
            address: '',
            addressComplement: '',
            addressNumber: '',
            addressReference: '',
            cep: '',
            city: '',
            neighborhood: '',
            state: '',
            alias: ''
          },
          dateStart: '',
          dateEnd: '',
          id: '',
          returnSchedule: false,
          status: '',
          type: '',
          calendarId: '',
          calendar: {
            id: '',
            alias: '',
            type: ''
          },
          teleUrl: '',
          allowReschedule: false,
          isNeedCollectCSAT: false,
          user: {} as IUser,
          calendarServiceType: {} as CalendarServiceType,
          attendanceConfirmed: false
        }
      ],
      payments: [],
      product: {
        id: '',
        name: '',
        alias: ''
      },
      haveToAnswerAnamnese: '',
      doctor: {
        name: '',
        profileImage: '',
        profileUrl: '',
        id: ''
      },
      steps: {
        currentStep: '',
        nextSteps: '',
        previousSteps: ''
      },
      calendars: [
        {
          id: '',
          durationEvent: 0,
          type: '',
          alias: '',
          inviteFisicalAddress: ''
        }
      ],
      calendarSecundary: {
        id: '',
        durationEvent: 0,
        type: '',
        alias: '',
        inviteFisicalAddress: ''
      },
      files: {
        exams: [],
        reports: [],
        requests: [],
        surgicalReports: [],
        surgicalVideos: []
      },
      calendarTypes: [
        {
          calendarId: '',
          id: '',
          type: ECalendarType.MAIN,
          createdAt: '',
          productId: '',
          updatedAt: ''
        }
      ],
      canScheduleReturn: false,
      restrictReturn: false,
      scheduleTreatments: []
    }
  ]
};

export const Journeys = createSlice({
  name: 'journeys',
  initialState,
  reducers: {
    saveActiveJourneys: (state, action: PayloadAction<IJourneyResponse[]>) => {
      state.activeJourneys = action.payload;
    },
    saveDoneJourneys: (state, action: PayloadAction<IJourneyResponse[]>) => {
      state.doneJourneys = action.payload;
    }
  }
});

export const { saveActiveJourneys, saveDoneJourneys } = Journeys.actions;
export const journeysReducer = Journeys.reducer;
